import { type FlagAction, createFlagAction } from "@mnk/shared/models/flagAction";
import type { FlagRow } from "@mnk/shared/models/flagRow";
import * as XLSX from "xlsx";
import type { RowData } from "./parseDataRows";
import type { FlagColumnMap } from "./parseHeaderRows";

/**
 * エクセルファイルからFlagを構築する
 */
export const buildFlagActions = (
  quantityId: string,
  row: RowData,
  flagRow: FlagRow,
  flagColumnMap: FlagColumnMap,
  sheetName: string,
) => {
  const flagActions: FlagAction[] = [];

  for (const [_, { sheets, flagColumn }] of Object.entries(flagColumnMap)) {
    if (!sheets[sheetName]) continue;
    const { baseColumn, modifiedColumn } = sheets[sheetName];
    if (!baseColumn && !modifiedColumn) continue;

    let value: string | null = null;
    let modifiedValue: string | null = null;

    if (baseColumn) {
      const baseColumnLetter = XLSX.utils.encode_col(baseColumn);
      value = row[baseColumnLetter] ? String(row[baseColumnLetter]) : null;
    }

    if (modifiedColumn) {
      const modifiedColumnLetter = XLSX.utils.encode_col(modifiedColumn);
      modifiedValue = row[modifiedColumnLetter] ? String(row[modifiedColumnLetter]) : null;
    }

    if (value == null && modifiedValue == null) continue;

    // 数値に変換できる場合は小数点第3位までに変換
    if (value !== null) {
      const num = Number(value);
      if (!Number.isNaN(num)) {
        value = Number(num.toFixed(3)).toString();
      }
    }

    if (modifiedValue !== null) {
      const num = Number(modifiedValue);
      if (!Number.isNaN(num)) {
        modifiedValue = Number(num.toFixed(3)).toString();
      }
    }

    const flagAction = createFlagAction({
      quantityId,
      flagColumnId: flagColumn.id,
      flagRowId: flagRow.id,
      value,
      modifiedValue,
    });

    flagActions.push(flagAction);
  }

  return {
    flagActions,
  };
};
